// Whether the microphone should publish enabled the moment a voice room
// connection is established, instead of the historical always-off default
// (see useVoiceConnection.js). A user preference, not a per-room/per-session
// one - same localStorage-backed pattern as theme/videoWatchVolume/
// screenShareVolume, read by Settings.js (to show/change it) and
// useVoiceConnection.js (to apply it on connect).
const MIC_DEFAULT_ON_KEY = 'micDefaultOn';

export function getMicDefaultOn() {
  return localStorage.getItem(MIC_DEFAULT_ON_KEY) === 'true';
}

export function setMicDefaultOn(value) {
  localStorage.setItem(MIC_DEFAULT_ON_KEY, value ? 'true' : 'false');
}
